module.exports = __webpack_public_path__ + "img/digital-marketing-1433427_1920.00c95aed.jpg";